import _isFunction from 'lodash/isFunction'
import _merge from 'lodash/merge'
import apiAxios from '../../_framework/axios/api-axios'
import tripDashboardAxios from '../../_framework/axios/trip-dashboard-axios'
import Store from '../../_stores/StoreCollection.js'

let TripsDashboardsCollection = {}

_merge(TripsDashboardsCollection, Store, {
  state: {
    apiBaseUrl: '/api/trip-dashboard/v1'
  }
})

/*
|--------------------------------------------------------------------------
| TRIP CLASS
|--------------------------------------------------------------------------
*/

class TripDashboard {
  static hasAgent(trip) {
    return trip && trip.travel_agent_id && trip.travel_agent
  }
}

/*
|--------------------------------------------------------------------------
| HELPERS METHODS
|--------------------------------------------------------------------------
*/

function setupDashboard($store, dashboardId, dashboardData, callback = null) {
  $store.commit('setCurrentDashboard', {
    dashboardId,
    data: dashboardData
  })

  return setupDashboardResources($store, dashboardId, callback)
}

function setupDashboardResources($store, dashboardId, callback = null) {
  // @todo, refactor this with V2 resources
  $store.dispatch('setupTripResources')

  return Promise.all([
    // note: we could use a hook system for this?
    $store.dispatch('AttachmentsV2/fetch'),
    $store.dispatch('PIFsV2/bootFor', ['where', 'trip_dashboard_id', dashboardId]),
    // Invoices: PR #245 switched this to bootForTripDashboard (GET v2 …/trip-dashboard/:id).
    // That returns InvoiceIndexEntry only — Vue invoice pages need v1 Crud search append fields
    // (invoice_history_result, payments, …). TripDashboardController does not put invoices in
    // window.appInitialData (only shallow dashboards + stores). Gift rows are still excluded
    // server-side when the query scopes by trip_dashboard_id (Invoice V1 InvoiceController::search).
    // Clear then search: matches old bootForTripDashboard reset; setMany() merges by id and would
    // otherwise retain invoices from another dashboard; bootFor() skips fetch if collection.length.
    Promise.resolve().then(() => {
      $store.commit('Invoices/set', { field: 'collection', value: [] })
      return $store.dispatch('Invoices/search', ['where', 'trip_dashboard_id', dashboardId])
    })
  ]).then(() => {
    if (_isFunction(callback)) {
      callback()
    }
  })
}

/**
 * Refresh trip dashboard data by reloading from server
 * Used when external changes (e.g., from React Assistant) require Vue 2 to refresh
 * @param {any} $store - Vuex store instance
 * @param {number} dashboardId - Trip dashboard ID to refresh
 * @returns {Promise} Promise that resolves when refresh is complete
 */
function refreshTripDashboard($store, dashboardId) {
  return tripDashboardAxios.get(`${dashboardId}/get`).then(response => {
    if (response.status === 200) {
      setupDashboard($store, dashboardId, response.data, () => {
        $store.commit('setClientUsers', response.data.clients)
      })
      return response.data
    } else {
      throw new Error('Failed to refresh trip dashboard')
    }
  })
}

function toggleOmitTermsAndConditionsSignature($store, dashboardId) {
  apiAxios
    .get(`v1/trip-dashboard/${dashboardId}/toggleOmitTermsAndConditionsSignature`)
    .then(res => {
      $store.dispatch('updateTripDashboardOmitTermsAndConditionsSignature', res.data)
    })
}

function toggleGlobalPifAccessAll($store, dashboardId, clientId) {
  return apiAxios
    .get(`v1/trip-dashboard/${dashboardId}/users/${clientId}/toggle-pif-access-for-user`)
    .then(res => {

      return $store.dispatch('updateClientPifAccess', {
        clientId,
        value: res.data
      })
    })
}


/*
|--------------------------------------------------------------------------
| EXPORTS
|--------------------------------------------------------------------------
*/

export default TripsDashboardsCollection
export {
  TripsDashboardsCollection,
  TripDashboard,
  setupDashboard,
  setupDashboardResources,
  toggleOmitTermsAndConditionsSignature,
  toggleGlobalPifAccessAll,
  refreshTripDashboard
}
